import { Header, PageNotFound } from "components/common";
import Favorites from "components/Favorites";
import Movie from "components/Movie";
import { Switch, Route } from "react-router-dom";

import "./App.css";
import routes from "./route";

const App = () => (
  <>
    <Header />
    <Switch>
      <Route exact component={Movie} path={routes.root} />
      <Route exact component={Favorites} path={routes.favorites} />
      <Route exact component={PageNotFound} path={routes.anyPath} />
    </Switch>
  </>
);

export default App;
